import { useEffect } from 'react';
import { useGame } from './state/GameContext';
import { useWebSocket } from './hooks/useWebSocket';
import { useTimer } from './hooks/useTimer';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeScreen from './screens/HomeScreen';
import WaitingRoom from './screens/WaitingRoom';
import GameScreen from './screens/GameScreen';
import ResultsScreen from './screens/ResultsScreen';
import TutorialPopup from './TutorialPopup';
import PrivacyPopup from './PrivacyPopup';

function App() {
  const { state, dispatch } = useGame();

  useWebSocket();
  useTimer();

  // Check URL for room code on mount + restore session from localStorage
  useEffect(() => {
    const path = window.location.pathname;
    const urlRoomCode = path.replace('/', '').trim();

    if (urlRoomCode && /^\d{6}$/.test(urlRoomCode)) {
      dispatch({ type: 'SET_FIELD', field: 'roomCode', value: urlRoomCode });

      const savedSession = localStorage.getItem('photoBlenderSession');
      if (savedSession) {
        try {
          const session = JSON.parse(savedSession);
          if (session.roomCode === urlRoomCode && session.playerId && session.playerName && session.authToken) {
            dispatch({
              type: 'JOIN_SUCCESS',
              playerId: session.playerId,
              roomCode: urlRoomCode,
              authToken: session.authToken,
              isHost: session.isHost || false,
              playerName: session.playerName,
            });
            return;
          }
        } catch {
          localStorage.removeItem('photoBlenderSession');
        }
      }

      dispatch({ type: 'SET_FIELD', field: 'currentView', value: 'join' });
    } else {
      const savedSession = localStorage.getItem('photoBlenderSession');
      if (savedSession) {
        try {
          const session = JSON.parse(savedSession);
          if (session.playerName) dispatch({ type: 'SET_FIELD', field: 'playerName', value: session.playerName });
          if (session.roomCode) dispatch({ type: 'SET_FIELD', field: 'roomCode', value: session.roomCode });
          if (session.playerId) dispatch({ type: 'SET_FIELD', field: 'playerId', value: session.playerId });
          if (session.isHost) dispatch({ type: 'SET_FIELD', field: 'isHost', value: session.isHost });

          if (session.roomCode && session.playerId && session.playerName) {
            dispatch({ type: 'SHOW_SUCCESS', message: `Found previous session in room ${session.roomCode}. Rejoin?` });
          }
        } catch {
          localStorage.removeItem('photoBlenderSession');
        }
      }
    }

    const tutorialSeen = localStorage.getItem('photoBlenderTutorialSeen');
    if (!tutorialSeen) {
      dispatch({ type: 'SET_FIELD', field: 'showTutorial', value: true });
    }
  }, [dispatch]);

  const renderScreen = () => {
    switch (state.currentView) {
      case 'waiting':
        return <WaitingRoom />;
      case 'game':
        return <GameScreen />;
      case 'results':
        return <ResultsScreen />;
      default:
        return <HomeScreen />;
    }
  };

  return (
    <div className="app">
      {state.showTutorial && <TutorialPopup onClose={() => dispatch({ type: 'SET_FIELD', field: 'showTutorial', value: false })} />}
      {state.showPrivacyPopup && <PrivacyPopup onClose={() => dispatch({ type: 'SET_FIELD', field: 'showPrivacyPopup', value: false })} />}

      <div className="container">
        <Header />

        {state.error && <div className="error">{state.error}</div>}
        {state.success && <div className="success">{state.success}</div>}

        {renderScreen()}

        {/* Loading indicator removed — individual components show their own progress */}

        <Footer />
      </div>
    </div>
  );
}

export default App;
